import { useEffect, useRef, useState } from 'react';
import './SegmentedControl.css';

export default function SegmentedControl({ value, onChange, options }) {
  const [openIndex, setOpenIndex] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpenIndex(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const select = (val) => {
    onChange?.(val);
    setOpenIndex(null);
  };

  return (
    <div className="segmented-control" ref={wrapperRef}>
      {options.map((option, index) => {
        const hasSubOptions = Array.isArray(option.options);
        const selectedSub = hasSubOptions
          ? option.options.find((sub) => sub.value === value)
          : null;
        const active = hasSubOptions ? !!selectedSub : option.value === value;
        const isOpen = openIndex === index;

        return (
          <div key={option.label} className="segmented-control-option-wrapper">
            <div className="segmented-control-option-container">
              <button
                type="button"
                className={`segmented-control-option ${active ? 'active' : ''}`}
                onClick={() => {
                  if (option.disabled) return;
                  if (hasSubOptions) {
                    setOpenIndex(isOpen ? null : index);
                  } else {
                    select(option.value);
                  }
                }}
                disabled={option.disabled}
              >
                {selectedSub ? `${option.label}: ${selectedSub.label}` : option.label}
              </button>

              {hasSubOptions && isOpen && !option.disabled && (
                <div className="segmented-control-dropdown">
                  {option.options.map((sub) => (
                    <button
                      key={sub.value}
                      type="button"
                      className={`segmented-control-dropdown-item ${sub.value === value ? 'active' : ''}`}
                      onClick={() => select(sub.value)}
                      disabled={sub.disabled}
                    >
                      {sub.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {index < options.length - 1 && (
              <span className="segmented-control-divider" aria-hidden />
            )}
          </div>
        );
      })}
    </div>
  );
}
